/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Ui_Filter_ElevationInputs */

const en_ui_filter_elevation = /** @type {(inputs: Ui_Filter_ElevationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} m climb`)
};

const de_ui_filter_elevation = /** @type {(inputs: Ui_Filter_ElevationInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.value} Hm`)
};

/**
* | output |
* | --- |
* | "{value} m climb" |
*
* @param {Ui_Filter_ElevationInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_filter_elevation = /** @type {((inputs: Ui_Filter_ElevationInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Filter_ElevationInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_filter_elevation(inputs)
	return de_ui_filter_elevation(inputs)
});